var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAudioPause = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 35 35"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 19406",
  transform: "translate(-91 -555.063)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 17.5,
  cy: 17.5,
  r: 17.5,
  fill: "none",
  "data-name": "Ellipse 16",
  transform: "translate(91 555.063)"
}), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 15199"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M97 561.062h24v24H97z",
  "data-name": "Rectangle 6441"
})), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeWidth: 1.5,
  "data-name": "Group 16253"
}, /*#__PURE__*/React.createElement("path", {
  d: "M105.5 567.073v10.983",
  "data-name": "Path 16692"
}), /*#__PURE__*/React.createElement("path", {
  d: "M111.5 567.073v10.983",
  "data-name": "Path 16693"
})))));
export { SvgAudioPause as ReactComponent };
export default __webpack_public_path__ + "static/media/audio_pause.a79f4df17ea25f902ddd148e790a932c.svg";